var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visiable
    ? _c("div", { staticClass: "preview-dialog" }, [
        _c("div", { staticClass: "mask" }),
        _c("div", { staticClass: "dialog-main" }, [
          _c(
            "header",
            { staticClass: "dialog-header" },
            [
              _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _c("svg-icon", {
                staticClass: "close-icon",
                attrs: { "icon-class": "close2" },
                on: { click: _vm.close },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "dialog-content" }, [
            _c("img", {
              staticClass: "preview-img",
              attrs: { src: _vm.imgSrc },
            }),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }